import { useNavigate } from 'react-router-dom';

import Typography from 'components/Typography';
import { IconSystemAvatar } from 'components/Icons';

import { useAnalytics } from 'hooks/useAnalytics';
import { useConversation } from 'hooks/conversation';

import { DataDogLogger } from 'utils/dataDog';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';
import { getLocalStorageItem } from 'utils/browserCache';
import { htmlId } from 'utils/html';

import { button } from './content';
import { ROUTES } from 'routes/constants';
import {
  StyledChatHistoryWrapper,
  StyledDivider,
  StyledHistoryItem,
  StyledHistoryLeftContent,
  StyledHistoryRightContent,
} from './styles';
import { ANALYTICS } from 'analytics/constants';
import { AnalyticClickedDetailsType, AnalyticReconnectedDetailsType } from 'analytics/types';
import { ACTIONS } from 'constants/hook';
import { LOCAL_STORAGE_KEY } from 'constants/browserCache';

const ChatHistory = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  const { conversationState, dispatchConversationAction } = useConversation();

  const existingCache = getLocalStorageItem(LOCAL_STORAGE_KEY.CVNA_CHAT_UI);
  const conversationMsgCount = existingCache?.conversationMsgCount ?? 0;

  if (!conversationState.isExistingConversation || !conversationMsgCount) {
    return null;
  }

  const handleClick = () => {
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.CLICKED,
      details: {
        analytic_click_id: id,
        content: button,
      } as AnalyticClickedDetailsType,
    });
    navigate(ROUTES.CHAT);
    if (conversationState.isInactivityTimeout) {
      const context = { method: 'Continue conversation' };
      DataDogLogger.action(CUSTOM_ACTION_NAMES.INACTIVITY_RECONNECT, context);
      trackEvent({
        analyticEvent: ANALYTICS.EVENT.CHAT_RECONNECTED,
        details: { reconnect_method: context.method } as AnalyticReconnectedDetailsType,
      });
    }
    const needsInitialization =
      !conversationState.isConnected && !conversationState.isInitializationRequested;
    if (needsInitialization) {
      dispatchConversationAction({
        type: ACTIONS.CHANGE,
        payload: { isInitializationRequested: true },
      });
    }
  };

  return (
    <StyledChatHistoryWrapper id={id}>
      <StyledDivider />
      <StyledHistoryItem id={htmlId('btn-continue-conversation')} onClick={handleClick}>
        <StyledHistoryLeftContent>
          <IconSystemAvatar />
        </StyledHistoryLeftContent>
        <StyledHistoryRightContent>
          <Typography as='span' color='strong' variant='label' size='md'>
            {button}
          </Typography>
        </StyledHistoryRightContent>
      </StyledHistoryItem>
    </StyledChatHistoryWrapper>
  );
};

export default ChatHistory;
